<template>
  <div class="news">
    <!-- LAST NEWS ITEM -->
    <div class="news-last" v-if="lastNews && page === 1" @click="goToNewsItem(lastNews._id)">
      <img :src="`${path}/${lastNews.cover}`" alt="Latest news" />
      <div class="text-group">
        <h3 class="text-accent">
          {{ lastNews.date | formatDateDot }} &#124;
          {{ lastNews[$i18n.locale].label }}
        </h3>
        <h2 class="text-light">{{ lastNews[$i18n.locale].title }}</h2>
        <p class="text-light">
          {{ lastNews[$i18n.locale].subtitle.substr(0, 80) }}...
        </p>
        <router-link :to="`/news?id=${lastNews._id}`" class="link">
          <span class="text-light">{{ $t("news-1") }}</span>
        </router-link>
      </div>
    </div>
    <div class="news-container-header">
      <div class="text-group" v-if="!$route.query.type">
        <h3 class="text-accent">{{ $t("news-2") }}</h3>
        <h1>{{ $route.name === 'lifeRecad' ? $t("news-3-liferecad") : $t("news-3") }}</h1>
      </div>
      <div class="text-group" v-else-if="$route.query.type === 'media'">
        <h3 class="text-accent">{{ $t("news-5") }}</h3>
        <h1>{{ $t("news-6") }}</h1>
      </div>
      <div class="text-group" v-else-if="$route.query.type === 'gallery'">
        <h3 class="text-accent">{{ $t("news-8") }}</h3>
        <h1>{{ $t("news-9") }}</h1>
      </div>
      <div class="text-group" v-else-if="$route.query.type === 'kcm-today'">
        <h3 class="text-accent">{{ $t("news-11") }}</h3>
        <h1>{{ $t("news-12") }}</h1>
      </div>
      <!-- <div class="year-wrapper">
        <p v-if="!$route.query.type">{{ $t('news-4') }}:</p>
        <p v-else-if="$route.query.type === 'media'">{{ $t('news-7') }}:</p>
        <p v-else-if="$route.query.type === 'gallery'">{{ $t('news-10') }}:</p>
        <select>
          <option value="2019">2019</option>
          <option value="2019">2018</option>
          <option value="2019">2017</option>
          <option value="2019">2016</option>
          <option value="2019">2015</option>
          <option value="2019">2014</option>
          <option value="2019">2013</option>
          <option value="2019">2012</option>
          <option value="2019">2011</option>
        </select>
      </div>-->
    </div>
    <div v-if="$route.query.type === 'kcm-today'">
      <CompaniesList :files="kcmTodayFiles" />
    </div>
    <div v-else class="news-container" ref="newsContainer">
      <div class="square-left" :style="{ top: percent + '%' }"></div>
      <div class="square-right" :style="{ top: percent * 0.98 + '%' }"></div>
      <div v-for="n in news.news" :key="`news-item-${n._id}`" class="news-item" @click="goToNewsItem(n._id)">
        <div class="news-item-cover" :style="{ backgroundImage: `url('${path}/${n.cover}')` }"></div>
        <div class="text-group">
          <!-- limit to 80 -->
          <h2>{{ n[$i18n.locale].title }}</h2>
          <!-- limit to 70 -->
          <p>{{ n[$i18n.locale].subtitle.substr(0, 80) }}...</p>
          <router-link to="/news?id=idIsGoingToBeHere" class="link">
            <span class="text-main-home">{{ $t("news-1") }}</span>
          </router-link>
        </div>
      </div>
    </div>
    <Pagination v-if="true" :total="news.total" :page="page" :size="size" />
  </div>
</template>

<script>
import CompaniesList from "../kcmGroup/CompaniesList.vue";
import Pagination from "../shared/Pagination";
export default {
  components: {
    Pagination,
    CompaniesList,
  },
  computed: {
    kcmTodayFiles() {
      return [
        {
          name: this.$t("news-files-4-name"),
          desc: this.$t("news-files-4-desc"),
          img: require("@/assets/img/news/kcm-today/br4.png"),
          file: {
            type: "pdf",
            url: "https://heyzine.com/flip-book/b0168593b2.html",
          },
        },
        {
          name: this.$t("news-files-3-name"),
          desc: this.$t("news-files-3-desc"),
          img: require("@/assets/img/news/kcm-today/br3.png"),
          file: {
            type: "pdf",
            url: "https://heyzine.com/flip-book/b7544abdbb.html",
          },
        },
        {
          name: this.$t("news-files-2-name"),
          desc: this.$t("news-files-2-desc"),
          img: require("@/assets/img/news/kcm-today/br2.png"),
          file: {
            type: "pdf",
            url: "https://heyzine.com/flip-book/1d555b7b56.html",
          },
        },
        {
          name: this.$t("news-files-1-name"),
          desc: this.$t("news-files-1-desc"),
          img: require("@/assets/img/news/kcm-today/br1.png"),
          file: {
            type: "pdf",
            url: "https://heyzine.com/flip-book/a9b3d909c3.html",
          },
        },
      ];
    },
  },
  data() {
    return {
      path: process.env.VUE_APP_UPLOADS_URI,
      page: 1,
      size: 14,
      type: "news",
      percent: 0,
      news: [],
      lastNews: null,
    };
  },
  watch: {
    $route() {
      this.getLastNews();
      this.getNews();
    },
    "$i18n.locale"() {
      this.getLastNews();
      this.getNews();
    },
  },
  methods: {
    goToNewsItem(id) {
      this.$router.push({ query: { id: id } });
    },
    changePage(p) {
      this.page = p;
      this.getNews();
      window.scrollTo(0, 0);
    },
    handleScroll() {
      const h = document.documentElement;
      const b = document.body;
      const st = "scrollTop";
      const sh = "scrollHeight";
      this.percent =
        ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
    },
    getNews() {
      if (this.$route.query.type) {
        this.type = this.$route.query.type;
      } else {
        this.type = "news";
      }

      if (this.$route.name === "lifeRecad") {
        this.type = "news-liferecad";
      }

      let url = `${process.env.VUE_APP_BASE_URI}/news?type=${this.type}&size=${this.size}&page=${this.page}`;

      if (this.$i18n.locale === "en") {
        url += "&en=true";
      }

      this.$http
        .get(url)
        .then((result) => {
          this.news = result.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLastNews() {
      if (this.$route.query.type) {
        this.type = this.$route.query.type;
      } else {
        this.type = "news";
      }

      if (this.$route.name === "lifeRecad") {
        this.type = "news-liferecad";
      }

      let url = `${process.env.VUE_APP_BASE_URI}/news?type=${this.type}&size=1&page=${this.page}`;

      if (this.$i18n.locale === "en") {
        url += "&en=true";
      }

      this.$http
        .get(url)
        .then((result) => {
          this.lastNews = result.data.news[0];
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getLastNews();
    this.getNews();

    document.addEventListener("scroll", this.handleScroll);
    this.$on("page-changed", this.changePage);
  },
  destroyed() {
    document.removeEventListener("scroll", this.handleScroll);
    this.$off("page-changed", this.changePage);
  },
};
</script>

<style lang="scss" scoped>
.news {
  .news-last {
    background-position: center;
    background-size: cover;
    cursor: pointer;
    margin: 15px auto 0;
    position: relative;
    width: calc(100% - 240px);

    img {
      height: auto;
      width: 100%;
    }

    .text-group {
      background-color: rgba(22, 65, 148, 0.9);
      left: $sidesPadding;
      padding: 25px;
      position: absolute;
      bottom: -25px;
      width: 40%;

      h2,
      h3,
      p,
      .link {
        z-index: 1;
      }
    }
  }

  .news-container-header {
    align-items: flex-end;
    display: flex;
    justify-content: space-between;
    padding: 50px $sidesPadding 25px;
    position: relative;

    .year-wrapper {
      align-items: center;
      display: flex;

      p {
        font-size: 16px;
        font-weight: 500;
        margin-right: 20px;
      }
    }

    select {
      -moz-appearance: none;
      -webkit-appearance: none;
      appearance: none;
      background-color: transparent;
      background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSI3LjQiIHZpZXdCb3g9IjAgMCAxMiA3LjQiPiAgPHBhdGggaWQ9InBhdGgiIGQ9Ik0xNi42LDguNiwxMiwxMy4yLDcuNCw4LjYsNiwxMGw2LDYsNi02WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTYgLTguNikiIGZpbGw9IiMxNjQxOTQiIC8+PC9zdmc+);
      background-repeat: no-repeat, repeat;
      background-position: right 4px top 62%, 0 0;
      background-size: 12px auto, 100%;
      border: none;
      cursor: pointer;
      color: $mainColor;
      font-family: "Playfair Display";
      font-size: 36px;
      @include transform(translateY(-10%));
      outline: none;
      padding-right: 20px;
      position: relative;
      @include transition(all 0.6s $mainCubic);

      option {
        color: #000;
        font-family: "Rubik";
        font-size: 14px;
        text-align: right;
      }
    }

    select::-ms-expand {
      display: none;
    }

    select:hover {
      opacity: 0.8;
    }
  }

  .news-container-header::after {
    background-color: #b2c8d2;
    content: "";
    -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 20% 100%);
    clip-path: polygon(0 0, 100% 0, 100% 100%, 20% 100%);
    position: absolute;
    top: -50%;
    right: 0;
    height: 150%;
    opacity: 0.25;
    width: 50%;
    z-index: -1;
  }

  .news-container {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 0 $sidesPadding;
    padding-bottom: $sidesPadding / 2;
    position: relative;

    .square-left {
      background-color: #b2c8d2;
      left: 0;
      height: 10%;
      opacity: 0.25;
      position: absolute;
      top: 1%;
      @include transition(all 1s $mainCubic);
      width: 40%;
      z-index: -1;
    }

    .square-right {
      background-color: #b2c8d2;
      right: 0;
      height: 10%;
      opacity: 0.25;
      position: absolute;
      top: 0%;
      @include transition(all 0.6s $mainCubic);
      width: 58%;
      z-index: -1;
    }

    .news-item {
      background-color: #fff;
      cursor: pointer;
      margin-right: 5%;
      margin-top: 6vw;
      padding: 11vw 30px 30px;
      position: relative;
      @include transition(all 0.6s $mainCubic);
      width: 20%;
      z-index: 1;

      .news-item-cover {
        background-position: center;
        background-size: cover;
        height: 15vw;
        left: 30px;
        top: -4vw;
        position: absolute;
        @include transition(all 0.6s $mainCubic);
        width: 105%;
      }

      .text-group {
        @include transition(all 0.6s $mainCubic);
        width: 100%;

        p {
          font-size: 13px;
          line-height: 18px;
          margin: 15px 0;
          opacity: 0.8;
        }

        h2 {
          margin: 15px 0;
        }

        h2,
        p,
        .link {
          @include transition(all 0.6s $mainCubic);
        }
      }
    }

    .news-item:nth-child(14n + 12),
    .news-item:nth-child(14n + 7) {
      margin-right: 10%;
      width: 40%;
      padding-top: 16vw;

      .news-item-cover {
        height: 20vw;
        width: 115%;
      }

      // .text-group {
      //   p {
      //     display: none;
      //   }
      // }
    }

    .news-item:hover::before {
      opacity: 1;
    }

    .news-item:hover {
      background-color: $mainColor;
      margin-right: 0;
      width: 25%;

      .news-item-cover {
        left: 5%;
        width: 90%;
      }

      .text-group {
        width: 75%;

        h2,
        p,
        .link span {
          color: #fff;
        }
      }
    }

    .news-item:nth-child(14n + 12):hover,
    .news-item:nth-child(14n + 7):hover {
      width: 50%;
      margin-right: 0;

      .news-item-cover {
        left: 2.5%;
        width: 95%;
      }

      .text-group {
        width: 80%;
      }
    }
  }

  .pagination {
    margin-bottom: $sidesPadding / 2;
  }
}

@media screen and (max-width: 1600px) {
  .news {
    .news-last {
      width: calc(100% - 200px);

      .text-group {
        left: $sidesPadding1600;
      }
    }

    .news-container-header {
      padding: 50px $sidesPadding1600 25px;
    }

    .news-container {
      padding: 0 $sidesPadding1600;
      padding-bottom: $sidesPadding1600 / 2;
    }
  }
}

@media screen and (max-width: 1280px) {
  .news {
    .news-last {
      width: calc(100% - 80px);

      .text-group {
        left: $sidesPadding1280;
      }
    }

    .news-container-header {
      padding: 50px $sidesPadding1280 25px;
    }

    .news-container {
      padding: 0 $sidesPadding1280;
      padding-bottom: $sidesPadding1280 / 2;

      .news-item {
        .text-group {
          p {
            display: none;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .news {
    .news-last {
      margin-top: $sidesPadding1280;

      .text-group {
        left: $sidesPadding1280;
        max-width: 80%;
        width: initial;

        p {
          display: none;
        }
      }
    }

    .news-container {
      padding: 0 $sidesPadding1280;
      padding-bottom: $sidesPadding1280 / 2;

      .news-item,
      .news-item:hover,
      .news-item:nth-child(14n + 12),
      .news-item:nth-child(14n + 7),
      .news-item:nth-child(14n + 12):hover,
      .news-item:nth-child(14n + 7):hover {
        margin-bottom: 2vw;
        margin-right: 5%;
        padding: 0 30px 30px;
        width: 45%;

        .text-group {
          width: 100%;

          h2 {
            line-height: 15px;
          }

          p {
            display: block;
            font-size: 11px;
            line-height: 13px;
          }

          .link {
            display: none;
          }
        }

        .news-item-cover {
          height: 20vh;
          left: 0;
          margin-top: -30px;
          top: 0;
          position: relative;
          width: calc(100% + 50px);
        }
      }
    }
  }
}

@media screen and (max-width: 700px) {
  .news {
    .news-container {

      .news-item,
      .news-item:hover,
      .news-item:nth-child(14n + 12),
      .news-item:nth-child(14n + 7),
      .news-item:nth-child(14n + 12):hover,
      .news-item:nth-child(14n + 7):hover {
        .news-item-cover {
          width: calc(100% + 40px);
        }
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .news {
    .news-last {
      margin: $sidesPadding600;
      width: calc(100% - 40px);

      .text-group {
        left: $sidesPadding600;
        max-width: 80%;
        padding: 15px;
        width: initial;

        h3 {
          line-height: 12px;
        }

        h2 {
          margin: 5px 0;
        }

        p {
          display: none;
        }

        .link {
          display: none;
        }
      }
    }

    .news-container-header {
      padding: $sidesPadding600;
      padding-top: $sidesPadding1280;
    }

    .news-container {
      padding: 0 $sidesPadding600;
      padding-bottom: $sidesPadding600 / 2;

      .news-item,
      .news-item:hover,
      .news-item:nth-child(14n + 12),
      .news-item:nth-child(14n + 7),
      .news-item:nth-child(14n + 12):hover,
      .news-item:nth-child(14n + 7):hover {
        margin-bottom: 3vw;
        padding-bottom: 10px;
        width: calc(100% - 30px);

        .news-item-cover {
          height: 40vw;
          width: calc(100% + 60px);
        }
      }
    }
  }
}

@media screen and (max-width: 420px) {
  .news {
    .news-container {

      .news-item,
      .news-item:hover,
      .news-item:nth-child(14n + 12),
      .news-item:nth-child(14n + 7),
      .news-item:nth-child(14n + 12):hover,
      .news-item:nth-child(14n + 7):hover {
        margin-bottom: 8vw;
      }
    }
  }
}
</style>
